import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsCreateHeader from '../components/leadsViewCreate/LeadsCreateHeader'
import LeadsCreateContent from '../components/customersCreate/CustomerCreateContent'
import Footer from '../components/shared/Footer'

const CustomersCreate = () => {
    return (
        <>
            <PageHeader>
  
            </PageHeader>

            <div className='main-content'>
                <div className='row'>
                    <LeadsCreateContent/>
                </div>
            </div>
            
        </>
    )
}

export default CustomersCreate